import type { ComponentType } from 'react';

import type { ManifestSection, SettingsManifest } from '@/lib/settingsApi';
import { AccountSection } from './AccountSection';
import { SecuritySection } from './SecuritySection';
import { NotificationsSection } from './NotificationsSection';
import { AppearanceSection } from './AppearanceSection';
import { DiarySection } from './DiarySection';

/**
 * Sections that have a real editor.
 *
 * A section absent from this map still renders — as the list of its settings with their true
 * state, and a link to the page where they are edited today. That fallback is what keeps the
 * shell honest while the remaining sections are built: it shows what exists rather than
 * pretending a section is finished.
 */
export type SectionComponent = ComponentType<{ section: ManifestSection; manifest: SettingsManifest }>;

export const SECTION_COMPONENTS: Record<string, SectionComponent> = {
  account: AccountSection,
  security: SecuritySection,
  notifications: NotificationsSection,
  appearance: AppearanceSection,
  diary: DiarySection,
};
